/* eslint-disable  */
import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './AffirmAsLowAs.module.scss';

import AffirmForm from '../AffirmForm';
import { getCookie } from '../../utils/common/common';
import useDrupalSettings from '../../hooks/useDrupalSettings';
import { AB_TEST_AFFIRM } from '../../utils/common/constants';
import messages from './messages';
import { useIntl } from 'react-intl';

/**
 * Despite being named Affirm, this widget displays all possible BNPL options
 * and supports A/B testing.
 */
const AffirmAsLowAs = ({ total = 0, skus = '', showAffirm }) => {
  const { pur_pt: purPt } = useDrupalSettings();
  const abTestAffirmName = purPt?.atName;
  const abTestAffirmValue = purPt?.atGroup;
  const abTestAffirmCookie = getCookie(abTestAffirmName)?.value;
  const abTestAffirm = AB_TEST_AFFIRM;
  const dispatch = useDispatch();
  const { formatMessage, formatNumber } = useIntl();

  useEffect(() => {
    if (abTestAffirmCookie && abTestAffirmCookie === abTestAffirmValue) {
      let affirmTestIds = {};
      const affirmId = Object.entries(abTestAffirm)
        .map((affirmTestAttributes) => {
          if (!affirmTestAttributes[1].maxPrice) {
            affirmTestIds = {
              dataPromoId: affirmTestAttributes[1].dataPromoId,
              financingProgram: affirmTestAttributes[1].financingProgram,
            };
          } else if (
            affirmTestAttributes[1].minPrice <= total &&
            affirmTestAttributes[1].maxPrice &&
            affirmTestAttributes[1].maxPrice >= total
          ) {
            affirmTestIds = {
              dataPromoId: affirmTestAttributes[1].dataPromoId,
              financingProgram: affirmTestAttributes[1].financingProgram,
            };
          } else {
            affirmTestIds = false;
          }
          return affirmTestIds;
        })
        .filter(Boolean);
      dispatch({
        type: 'setAffirmFinancingProgramme',
        affirmFinancingProgramme: affirmId[0]?.financingProgram,
      });
      // TODO: Change this script into react. Affirm is reading data-promo-id from the HTML.
      // React DOM change is happening after affirm reading the data. So DOM has to be changed forecefully
      // to make data-promo-id avaialble to affirm
      if (affirmId[0]?.dataPromoId) {
        document
          .getElementById('affirm-price-update')
          .setAttribute('data-promo-id', affirmId[0]?.dataPromoId);
      } else {
        document
          .getElementById('affirm-price-update')
          .removeAttribute('data-promo-id');
      }
      window.affirm?.ui?.refresh?.();
    }
  }, [abTestAffirmCookie, abTestAffirmValue, dispatch, total]);

  useEffect(() => {
    // TODO: Check if this useEffect can be removed.
    if (window.affirm) {
      try {
        // React DOM change is happening after affirm reading the data. So DOM has to be changed forecefully
        // to make data-promo-id avaialble to affirm
        // if (skus?.length > 0) {
        //   document.getElementById('affirm-price-update').setAttribute('data-sku', dataSku);
        // }
        window.affirm?.ui?.refresh?.();
      } catch (e) {
        console.log('AFFIRM ERROR', e);
      }
    }

  }, [total]);

  const onClick = useCallback((e) => e.preventDefault(), []);


  return (
    <>
      <AffirmForm />
      {showAffirm !== 0 && (
        <div className={styles['affirm']}>
          {showAffirm !== 2 && (
            <span>
              {formatMessage(messages.affirmPrefix)}
            </span>
          )}
          <span
            id="affirm-price-update"
            data-testid="affirm-as-low-as"
            data-amount={total}
            data-sku={skus}
            className={classnames(
              'affirm-as-low-as',
              styles['affirm-as-low-as-wrap'],
              {
                [styles['no-logo']]: showAffirm === 2,
              }
            )}
            data-page-type="category"
          >
          </span>
          {showAffirm !== 2 && (
            <span>
              {formatMessage(messages.affirmSuffix, {
                affirmLogo: (
                  <span className={styles['affirm-logo']}>
                    <img
                      alt={formatMessage(messages.affirmLogoAlt)}
                      src={`${process.env.ASSETS_URL}/images/svg/affirm-logo.svg`}
                      className={styles['affirm-img']}
                    />
                  </span>
                ),
              })}
            </span>
          )}
         
        </div>
      )}
    </>
  );
};

AffirmAsLowAs.propTypes = {
  total: PropTypes.number,
  skus: PropTypes.string,
  showAffirm: PropTypes.number.isRequired,
};

export default AffirmAsLowAs;
